module.exports = __webpack_public_path__ + "static/media/29-2.b8fbdfb0.mp3";